import { c as _c } from "react/compiler-runtime";
import { MonthActions } from "@website/ui/datepicker/components";
import styles from "@website/ui/datepicker/components/flat-header/flat-header.module.scss";
import { HeaderPropertiesType } from "@website/ui/datepicker/components/flat-header/flat-header.types";
import { WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { FC } from "react";
export const FlatHeader: FC<HeaderPropertiesType> = properties => {
  const $ = _c(19);
  const {
    calendarLocale: t0,
    showDates,
    scrolled,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled,
    type,
    view
  } = properties;
  const calendarLocale = t0 === undefined ? "gregorian" : t0;
  const t1 = `${styles.header} ${styles["rtl" || "ltr"]} ${scrolled ? styles.scrolled : ""}`;
  let t2;
  if ($[0] !== calendarLocale || $[1] !== nextMonthDisabled || $[2] !== previousMonthDisabled || $[3] !== showDates || $[4] !== showNextMonth || $[5] !== showPreviousMonth || $[6] !== type || $[7] !== view) {
    t2 = <MonthActions calendarLocale={calendarLocale} nextMonthDisabled={nextMonthDisabled} previousMonthDisabled={previousMonthDisabled} showDates={showDates} showNextMonth={showNextMonth} showPreviousMonth={showPreviousMonth} type={type} view={view} />;
    $[0] = calendarLocale;
    $[1] = nextMonthDisabled;
    $[2] = previousMonthDisabled;
    $[3] = showDates;
    $[4] = showNextMonth;
    $[5] = showPreviousMonth;
    $[6] = type;
    $[7] = view;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = `${styles["week-names-container-mobile"]} ${view === "mobile" ? "" : styles["week-names-container-mobile__default"]}`;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [1, 2, 3, 4, 5, 6, 7];
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== calendarLocale) {
    t5 = t4.map(item => <div className={styles["week-name"]} key={item}><div className={styles["aspect-ratio-content"]}>{WEEK_ABBR[calendarLocale]?.[item - 1] || WEEK_ABBR.gregorian[item - 1]}</div></div>);
    $[10] = calendarLocale;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className={t3}>{t5}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t1 || $[16] !== t2 || $[17] !== t6) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};